import { HaNewquestion } from "./HaNewQuestion.model";

export class SurveyInsertQuestionModal{
    constructor(
    private newQuestion:HaNewquestion,
    private answerTypeOptions:any[]



    ){

    }
}